var StoreList = {
  stores: [],
  markers: [],
  $ulStoreList: null,
  keyword: null,
  map: null,

  init: function(storeData, map, callback) {
    var self = this;
    self.map = map;
    self.$ulStoreList = $('#store-list');

    // URLからのデータ取得を削除し、直接データを使用
    self.stores = storeData.stores;
    
    // マーカーとリストの作成
    self.setMarkers();
    self.setPanel();
    
    if (typeof callback === 'function') {
      callback();
    }
  },

  setPanel: function () {
    var list = '';

    StoreList.stores.forEach(function (store) {
      var divStoreId = '<div class="store-id-wrapper"><span class="store-id">' + store.id + '</span></div>';
      var div = divStoreId + '<div class="shop-info"><div class="shop-info-title title">' + store.name + '</div><div id="store-address-' + store.id + '" class="store-address">' + '〒' + store.zip + '<br>' + store.address + '</div><div class="store-tel">' + store.tel + '</div></div>';
      var li = '<li id="store-' + store.id + '" class="store li-store" data-store-id="' + store.id + '" data-store-lat="' + store.lat + '" data-store-lng="' + store.lng + '">' + div + '</li>';

      list += li;
    });

    StoreList.$ulStoreList.append(list);
    StoreList.$liStores = $('.li-store');
    StoreList.$liStores.on('click', function () {
      var $that = $(this),
          storeId = $that.data('storeId');

      StoreList.$liStores.removeClass('selected');
      $that.addClass('selected');

      StoreList.map.setCenter(new google.maps.LatLng(
        $that.data('storeLat'),
        $that.data('storeLng')
      ));

      new google.maps.event.trigger(StoreList.markers[storeId], 'click');
    });
  },

  setMarkers: function () {
    StoreList.stores.forEach(function (store) {
      var cls = 'rich-marker';
      // store.idを文字列に変換してから長さを確認
      var storeIdStr = String(store.id);

      if (storeIdStr.length < 2) {
        cls += ' rich1';
      } else if (storeIdStr.length < 3) {
        cls += ' rich2';
      } else {
        cls += ' rich3';
      }

      var marker = new RichMarker({
        position: new google.maps.LatLng(store.lat, store.lng),
        shadow: 'none',
        content: '<div id="rich-marker-' + store.id + '" class="' + cls + '"><span class="rich-marker-store-id">' + store.id + '</span></div>',
        map: StoreList.map
      });

      marker.setValues({store_id: store.id});

      StoreList.setMarkerEvent(marker);

      StoreList.markers[store.id] = marker;
    });
  },

  setMarkerEvent: function (marker) {
    // markerにイベントを登録する
    google.maps.event.addListener(marker, 'click', function () {

      // panel
      StoreList.$liStores.removeClass('selected');
      var $store = $('#store-' + this.store_id);
      $store.addClass('selected');
      location.hash = 'store-' + this.store_id;

      if ('scrollingElement' in document) {
        var scrollableElement = document.scrollingElement;
      } else if (/*@cc_on!@*/false || (!!window.MSInputMethodContext && !!document.documentMode)) {
        var scrollableElement = document.documentElement;
      } else if (firefox && parseInt(firefox[1]) <= 47) {
        var scrollableElement = document.documentElement;
      } else {
        var scrollableElement = document.body;
      }

      scrollableElement.scrollTop = $('#map').offset().top - 30;      
      
       // marker
      $('.rich-marker').removeClass('selected');
      $('#rich-marker-' + this.store_id).addClass('selected');

      // map
      StoreList.map.setZoom(15);
      StoreList.map.panTo(this.getPosition());
    });;
  },

  showAllStores: function () {
    StoreList.$liStores.removeClass('hidden');

    StoreList.markers.forEach(function (marker) {
      marker.setVisible(true);
    });
  },

  hideAllStores: function () {
    StoreList.$liStores.addClass('hidden');

    StoreList.markers.forEach(function (marker) {
      marker.setVisible(false);
    })
  },

  toggleStores: function (word) {
    StoreList.hideAllStores();
    const searchWord = word.trim();
    let isFirstMatch = true;
  
    // 全角カタカナを半角に変換する関数
    const convertFullWidthKana = (str) => {
      // カタカナの変換マップ
      const kanaMap = {
        'ァ': 'ｧ', 'ア': 'ｱ', 'ィ': 'ｨ', 'イ': 'ｲ', 'ゥ': 'ｩ', 'ウ': 'ｳ', 'ェ': 'ｪ', 'エ': 'ｴ', 'ォ': 'ｫ', 'オ': 'ｵ',
        'カ': 'ｶ', 'キ': 'ｷ', 'ク': 'ｸ', 'ケ': 'ｹ', 'コ': 'ｺ',
        'サ': 'ｻ', 'シ': 'ｼ', 'ス': 'ｽ', 'セ': 'ｾ', 'ソ': 'ｿ',
        'タ': 'ﾀ', 'チ': 'ﾁ', 'ツ': 'ﾂ', 'テ': 'ﾃ', 'ト': 'ﾄ',
        'ナ': 'ﾅ', 'ニ': 'ﾆ', 'ヌ': 'ﾇ', 'ネ': 'ﾈ', 'ノ': 'ﾉ',
        'ハ': 'ﾊ', 'ヒ': 'ﾋ', 'フ': 'ﾌ', 'ヘ': 'ﾍ', 'ホ': 'ﾎ',
        'マ': 'ﾏ', 'ミ': 'ﾐ', 'ム': 'ﾑ', 'メ': 'ﾒ', 'モ': 'ﾓ',
        'ャ': 'ｬ', 'ヤ': 'ﾔ', 'ュ': 'ｭ', 'ユ': 'ﾕ', 'ョ': 'ｮ', 'ヨ': 'ﾖ',
        'ラ': 'ﾗ', 'リ': 'ﾘ', 'ル': 'ﾙ', 'レ': 'ﾚ', 'ロ': 'ﾛ',
        'ワ': 'ﾜ', 'ヲ': 'ｦ', 'ン': 'ﾝ',
        'ガ': 'ｶﾞ', 'ギ': 'ｷﾞ', 'グ': 'ｸﾞ', 'ゲ': 'ｹﾞ', 'ゴ': 'ｺﾞ',
        'ザ': 'ｻﾞ', 'ジ': 'ｼﾞ', 'ズ': 'ｽﾞ', 'ゼ': 'ｾﾞ', 'ゾ': 'ｿﾞ',
        'ダ': 'ﾀﾞ', 'ヂ': 'ﾁﾞ', 'ヅ': 'ﾂﾞ', 'デ': 'ﾃﾞ', 'ド': 'ﾄﾞ',
        'バ': 'ﾊﾞ', 'ビ': 'ﾋﾞ', 'ブ': 'ﾌﾞ', 'ベ': 'ﾍﾞ', 'ボ': 'ﾎﾞ',
        'パ': 'ﾊﾟ', 'ピ': 'ﾋﾟ', 'プ': 'ﾌﾟ', 'ペ': 'ﾍﾟ', 'ポ': 'ﾎﾟ',
        'ヴ': 'ｳﾞ',
        'ッ': 'ｯ'
      };
      
      return str.split('').map(char => kanaMap[char] || char).join('');
    };
  
    const showStore = function(store) {
      $('#store-' + store.id).removeClass('hidden');
      StoreList.markers[store.id].setVisible(true);
  
      if (isFirstMatch) {
        new google.maps.event.trigger(StoreList.markers[store.id], 'click');
        isFirstMatch = false;
      }
    };
  
    StoreList.stores.forEach(function (store) {
      // 検索ワードを半角カタカナに変換
      const normalizedSearchWord = convertFullWidthKana(searchWord.toLowerCase());
      
      const isMatch = 
        (store.name && store.name.toLowerCase().indexOf(normalizedSearchWord) !== -1) ||
        (store.address && store.address.indexOf(searchWord) !== -1) ||
        (store.tel && store.tel.indexOf(searchWord) !== -1) ||　
        (store.keywords && store.keywords.split(',').some(keyword => 
          keyword.trim().indexOf(searchWord) !== -1
        ));
  
      if (isMatch) {
        showStore(store);
      }
    });
  },
  
  getQueryString: function (name, url) {
    if (!url) {
      url = window.location.href;
    }

    name = name.replace(/[\[\]]/g, "\\$&");

    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);

    if (!results) {
      return null;
    }

    if (!results[2]) {
      return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
  
};
